import { render, staticRenderFns } from "./Config.vue?vue&type=template&id=e4e59be2&scoped=true&"
import script from "./Config.vue?vue&type=script&lang=js&"
export * from "./Config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e59be2",
  null
  
)

export default component.exports